var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEasypaisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.432 2.48827C12.432 2.48827 9.89117 -1.39965 4.36408 0.544309C4.36408 0.544309 1.37583 1.3666 0.0315128 6.14292C0.0315128 6.14292 2.79603 10.546 9.51764 9.12884C9.51764 9.12884 15.2685 7.63783 12.432 2.48827ZM8.80754 6.3762C7.685 6.9069 5.95742 6.76499 4.78625 6.45979C4.70259 6.4384 3.17345 5.89993 3.24349 5.76774C4.36603 3.69353 7.30369 1.78067 9.35228 3.90931C9.56303 4.11336 9.7172 4.36856 9.79973 4.64996C9.97482 5.35173 9.45928 6.07294 8.80754 6.38008V6.3762Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.031501 7.57562C0.031501 7.57562 -0.639688 12.7874 4.21427 14.5039C9.06822 16.2204 12.8794 13.0848 14 11.1447L11.2355 9.50403C11.2355 9.50403 9.07017 13.9751 2.86995 11.0709C2.86995 11.0709 0.628761 9.75091 0.031501 7.57562Z",
    fill: "#26B15D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEasypaisa);
export default __webpack_public_path__ + "static/media/easypaisa.2d0e14394e5c20ecc136496433262cae.svg";
export { ForwardRef as ReactComponent };